import CryptoJS from "crypto-js";

export type Config = { [key: string]: string };

export const getNewDimensions = (
  width: number,
  height: number,
  selected: number
): number[] => {
  const newWidth = width * (window.innerWidth / selected) || 0;
  const newHeight = height * (window.innerWidth / selected) || 0;
  return [Math.floor(newWidth), Math.floor(newHeight)];
};

const showFormattedDate = (date: any, publishedDate: any, format: any) => {
  if (date && date.toLowerCase() != "nan") {
    return formatDate(date, format);
  } else if (publishedDate && publishedDate.toLowerCase() != "nan") {
    return formatDate(publishedDate, format);
  } else {
    return;
  }
};

const removeTags = (str: any) => {
  if (str && str.length) {
    str = str.toString();
    str = str.replace(/&nbsp;/g, " ");
    str = str.replace(/&amp;/g, "&");
    str = str.replace(/(<([^>]+)>)/gi, "");
  }
  return str;
};

const formatDate = (date: any, format: any) => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const initialDate = date.split(/\//);

  const mm = initialDate[1];
  const dd = initialDate[0];
  const yyyy = initialDate[2];
  const dateToProcess = new Date([mm, dd, yyyy].join("/"));
  const month = months[dateToProcess.getMonth()];

  if (format.toLowerCase() == "dd/mm/yyyy") {
    return date;
  } else if (format.toLowerCase() == "mm/dd/yyyy") {
    return [mm, dd, yyyy].join("/");
  } else if (format.toLowerCase() == "yyyy/mm/dd") {
    return [yyyy, mm, dd].join("/");
  } else if (format.toLowerCase() == "month dd, yyyy") {
    return month + " " + dd + ", " + yyyy;
  } else if (format == "MMM DD, YYYY") {
    return (
      dateToProcess.toLocaleString("en-US", { month: "short" }).toUpperCase() +
      " " +
      dd +
      ", " +
      yyyy
    );
  } else if (format == "Mmm DD, YYYY") {
    return (
      dateToProcess.toLocaleString("en-US", { month: "short" }) +
      " " +
      dd +
      ", " +
      yyyy
    );
  }
};

const decryptHTML = (encryptedCode: string) => {
  const _ciphertext = CryptoJS.AES.decrypt(
    encryptedCode,
    "secret_code_iiris_target"
  );
  const c_text = _ciphertext.toString(CryptoJS.enc.Utf8);
  return c_text;
};

  const appendUtmQueryToTargetUrl = (attributes: any, browser_query: any) => {
    const formattedUrl = attributes.targetUrl.startsWith('http') ? attributes.targetUrl : `http://${attributes.targetUrl}`

    const [baseUrl, queryString] = formattedUrl.split("?");
    const urlParams = new URLSearchParams(queryString || "");

    if (browser_query === null){
      return
    }else {
      // Loop through each parameter from the browser
      browser_query.forEach((param: string) => {
        // Remove leading '?' or '&' and split into key and value
        const cleanParam = param.replace(/^[?&]/, '');
        const [key, value] = cleanParam.split('=');
        urlParams.set(decodeURIComponent(key), decodeURIComponent(value));
      });
      console.log(urlParams.toString());
      // Updating the target URL
      attributes.targetUrl = `${baseUrl}?${urlParams.toString()}`;
      console.log(attributes.targetUrl);
    }

  }

    const getRedirectMode = (config?: any) => {
    const redirectionMode = config.redirectMode;
    let mode;
    if (redirectionMode === "new") {
      mode = "_blank";
    } else if (redirectionMode === "same") {
      mode = "_self";
    }
    return mode;
  };

export { decryptHTML, formatDate, removeTags, showFormattedDate, appendUtmQueryToTargetUrl, getRedirectMode };